import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';

export interface BundlesRouterState {
    message?: string;
}

export enum BundlesFormControlName {
    STRING_FILTER = 'searchControl'
}

export interface BundlesFilters {
    [BundlesFormControlName.STRING_FILTER]?: string;
}

export interface BundlesStateModel {
    filterValue: BundlesFilters;
}

export const bundlesDefaultFilters: BundlesFilters = {
    [BundlesFormControlName.STRING_FILTER]: ''
};

export const bundlesStateDefaults: StateSliceDefaults<BundlesStateModel> = Object.freeze({
    sliceName: StateSliceName.BUNDLES,
    defaults: {
        filterValue: bundlesDefaultFilters
    }
});


export enum BundlesTableColumn {
    BUNDLE_NAME = 'bundleName',
    COMPANIES_WITH_BUNDLE = 'companiesWithBundle',
    LAST_UPDATED = 'lastUpdated',
    CTA = 'cta',
}

export interface BundlesTableRow {
    [BundlesTableColumn.BUNDLE_NAME]: string;
    [BundlesTableColumn.COMPANIES_WITH_BUNDLE]: number;
    [BundlesTableColumn.LAST_UPDATED]: {
        date: Date;
        label: string;
    };
    [BundlesTableColumn.CTA]: string;
}
